<app-header [isLoged]="userService.checkWithType()" [isLogedB2c]="this.b2cService.isLoggedIn()"></app-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>
<!-- <router-outlet (activate)="onActivate($event)">
<app-header [isLoged]="isLoged" [isLogedB2c]="isLogedB2c" (activate)="changeLoged($event)" ></app-header>
</router-outlet>
<app-footer></app-footer> -->
